module.exports = __webpack_public_path__ + "assets/d785d1bc622cb875c1d6236fce512b2a.png";